import {
  BarChart3,
  Building2,
  Calendar,
  Code2,
  Coins,
  CreditCard,
  Home,
  Settings,
  Tag,
  Users,
  type LucideIcon,
} from 'lucide-react';

export interface NavigationItem {
  name: string;
  href: string;
  icon: LucideIcon;
}

export interface NavigationCategory {
  name: string;
  items: NavigationItem[];
}

export const navigationCategories: NavigationCategory[] = [
  {
    name: 'DASHBOARD',
    items: [{ name: 'Vista General', href: '/dashboard', icon: Home }],
  },
  {
    name: 'SUBSCRIPTIONS',
    items: [
      { name: 'Suscripciones', href: '/subscriptions', icon: CreditCard },
      { name: 'Proveedores', href: '/providers', icon: Building2 },
      { name: 'Categorías', href: '/categories', icon: Tag },
    ],
  },
  {
    name: 'ANALYTICS',
    items: [
      { name: 'Reportes', href: '/reports', icon: BarChart3 },
      { name: 'Calendario', href: '/calendar', icon: Calendar },
    ],
  },
  {
    name: 'SETTINGS',
    items: [
      { name: 'Mi Plan', href: '/plan', icon: Coins },
      { name: 'Equipo', href: '/team', icon: Users },
      { name: 'Desarrollador', href: '/developer', icon: Code2 },
      { name: 'Configuración', href: '/settings', icon: Settings },
    ],
  },
];
